/* tslint:disable */

declare var Object: any;
export interface ZipcodeModificationFactorInterface {
  "ZipCode": string;
  "city"?: string;
  "cityAndState"?: string;
  "state"?: string;
  "EquipmentFactor"?: number;
  "LaborFactor"?: number;
  "MaterialsFactor"?: number;
  "id"?: any;
}

export class ZipcodeModificationFactor implements ZipcodeModificationFactorInterface {
  "ZipCode": string;
  "city": string;
  "cityAndState": string;
  "state": string;
  "EquipmentFactor": number;
  "LaborFactor": number;
  "MaterialsFactor": number;
  "id": any;
  constructor(data?: ZipcodeModificationFactorInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ZipcodeModificationFactor`.
   */
  public static getModelName() {
    return "ZipcodeModificationFactor";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ZipcodeModificationFactor for dynamic purposes.
  **/
  public static factory(data: ZipcodeModificationFactorInterface): ZipcodeModificationFactor{
    return new ZipcodeModificationFactor(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ZipcodeModificationFactor',
      plural: 'zipcodemodificationfactors',
      properties: {
        "ZipCode": {
          name: 'ZipCode',
          type: 'string'
        },
        "city": {
          name: 'city',
          type: 'string'
        },
        "cityAndState": {
          name: 'cityAndState',
          type: 'string'
        },
        "state": {
          name: 'state',
          type: 'string'
        },
        "EquipmentFactor": {
          name: 'EquipmentFactor',
          type: 'number'
        },
        "LaborFactor": {
          name: 'LaborFactor',
          type: 'number'
        },
        "MaterialsFactor": {
          name: 'MaterialsFactor',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/ZipcodeModificationFactor.ts